import { defineStore } from "pinia";
import { ref } from "vue";

export const useSchoolPlanStore = defineStore("schoolPlan", () => {
  /** @type {SchoolPlan} */
  const schoolPlan = ref({});

  return { schoolPlan };
});
